import styled from 'styled-components';

import Image from '../../Components/Image';

import NoImage from '../../Assets/Icons/NoImage.png';

export const ImageContainer = styled.div``;

export const ImageInputContainer = styled.div`
    align-items: center;
    background-image: url('${props => props.BackgroundImage}'), url('${NoImage}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    display: flex;
    height: 100px;
    justify-content: center;
    margin: 0 auto;
    max-width: 100%;
    overflow: hidden;
    position: relative;
    width: 100px;
`;

export const StyledInput = styled.input`
    bottom: 0;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;

    :hover {
        cursor: pointer;
    }
`;

export const StyledInputIcon = styled(Image)`
    height: 35px;
    width: 35px;
`;